{
  function getStickyHeaderHeight() {
    const header = document.querySelector('.main-header')
    let offset = 0
    if (header && window.getComputedStyle(header).position === 'sticky') {
      offset = header.offsetHeight
    }
    return offset
  }

  function hasStickyHeader() {
    const header = document.querySelector('.main-header')
    return header && window.getComputedStyle(header).position === 'sticky'
  }

  // we run this twice because we need to account for lazy loaded images and such
  function adjustScrollForAnchor(doItAgain, anchorSelector){
    // Defer adjusting the scroll until after the browser scrolls to the anchor
    requestAnimationFrame(() => {
      const offset = hasStickyHeader() ? getStickyHeaderHeight() : 0;
      const target = document.querySelector(anchorSelector)
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY
        window.scrollTo({ top: targetPosition - offset })
      }
      if(doItAgain){
        setTimeout(() => adjustScrollForAnchor(false, anchorSelector), 500)
      }
    })
  }

  document.querySelectorAll('a[href*="#"]:not(.back-to-top)').forEach(anchor => {
    if (anchor.hash && location.pathname === anchor.pathname && location.hostname === anchor.hostname) {
      try {
        const anchorIsOnPage = document.querySelector(anchor.hash)
        if(anchorIsOnPage){
          anchor.addEventListener('click', e => {
            e.preventDefault()
            history.pushState(null, '', anchor.hash)
            adjustScrollForAnchor(true, anchor.hash)
          })
        }
      } catch (e){

      }
    }
  })
}